<template>
    <div>
        <div v-if="loading" class="text-center">
            <v-progress-circular indeterminate size="60" width="6" color="primary"></v-progress-circular>
            <h3 class="secondary--text text-h5 mt-6">Loading your plan...</h3>
        </div>
        <div v-else-if="error">
            <h1 :class="this.$vuetify.breakpoint.smAndDown ? 'text-h5 text-center' : 'secondary--text text-h2'">
                We couldn't find that plan
            </h1>
            <h3 class="secondary--text text-h5">{{ error }}</h3>
            <v-footer :app="this.$vuetify.breakpoint.smAndDown" padless class="px-0 bg-transparent">
                <v-container fluid class="pa-0">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-card-actions class="d-flex justify-space-between px-0">
                                <v-btn x-large outlined color="primary" href="https://www.messageiq.io">
                                    Back to Message IQ
                                </v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-footer>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: "PlanLanding",
    data: () => ({
        loading: true,
        error: null
    }),
    async created() {
        const planId = this.$route.query.plan;

        if (!planId) {
            this.loading = false;
            this.error = "No plan was specified. Please use the link provided to you to start signup.";
            return;
        }

        try {
            await this.fetchPlan(planId);
            this.$router.push({ path: '/signup/message-iq/payment', query: this.$route.query });
        } catch (err) {
            this.loading = false;
            this.error = "This plan is no longer available. Please contact us for help getting started.";
            console.error(err);
        }
    },
    methods: {
        ...mapActions('messageIqSignup', ['fetchPlan'])
    }
};
</script>
